import { requests } from "../../services/http-common";

export type AccountDeletionAccountType = "customer" | "employee";

export interface AccountDeletionRequestPayload {
  fullName: string;
  email: string;
  accountType: AccountDeletionAccountType;
  reason?: string;
  confirm: true;
}

export interface AccountDeletionRequestResponse {
  id: string;
  status: "received";
}

export const submitAccountDeletionRequest = (
  payload: AccountDeletionRequestPayload
): Promise<AccountDeletionRequestResponse> =>
  requests.post("/account-deletion-requests", payload);
